import { getFeatureToggleClient } from 'infra/featureToggles'

export function isClientDataVerificationEnabled() {
  return getFeatureToggleClient().variation(
    'DocumentsAPI.VerifyClientData',
    false,
  )
}
